import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import UploadService from '../../_services/upload-files.service';

function taskWithPhotoUrls(task, index) {
    return {
        seq: index + 1,
        description: task && task.description ? task.description : '',
        photoUrls: Array.isArray(task && task.photoUrls) ? task.photoUrls : []
    };
}

export default function TpmTierPanel({ tierKey, title, tier, onChange, disabled }) {
    const [uploadingTask, setUploadingTask] = useState(null);
    const currentTier = tier || { intervalPcs: '', tasks: [] };
    const tasks = Array.from({ length: 10 }, (_value, index) => taskWithPhotoUrls(currentTier.tasks && currentTier.tasks[index], index));

    const updateTier = (updates) => onChange(tierKey, Object.assign({}, currentTier, updates));

    const updateTask = (taskIndex, updates) => {
        const nextTasks = tasks.map((task, index) => index === taskIndex ? Object.assign({}, task, updates) : task);
        updateTier({ tasks: nextTasks });
    };

    const uploadPhotos = async (taskIndex, event) => {
        const selectedFiles = Array.from(event.target.files || []);
        const currentPhotoUrls = tasks[taskIndex].photoUrls;
        if (!selectedFiles.length || currentPhotoUrls.length + selectedFiles.length > 5) return;

        setUploadingTask(taskIndex);
        try {
            const response = await UploadService.uploadImage(Array.from(event.target.files));
            const uploadedFiles = Array.isArray(response.data) ? response.data : [];
            const uploadedUrls = uploadedFiles
                .map(file => file.imgPath || (file.filename ? `img/${file.filename}` : ''))
                .filter(Boolean);
            updateTask(taskIndex, { photoUrls: currentPhotoUrls.concat(uploadedUrls).slice(0, 5) });
        } catch (_error) {
            window.alert('Could not upload task photos.');
        } finally {
            setUploadingTask(null);
            event.target.value = '';
        }
    };

    return (
        <section className="mb-4">
            <h4>{title}</h4>
            <Form.Group className="mb-3" controlId={`${tierKey}-interval-pcs`}>
                <Form.Label>Interval of PCS</Form.Label>
                <Form.Control
                    type="number"
                    min="1"
                    value={currentTier.intervalPcs}
                    disabled={disabled}
                    onChange={event => updateTier({ intervalPcs: event.target.value === '' ? '' : Number(event.target.value) })}
                />
            </Form.Group>

            {tasks.map((task, taskIndex) => (
                <div key={taskIndex} className="border rounded p-3 mb-3">
                    <Form.Group className="mb-2" controlId={`${tierKey}-task-${taskIndex + 1}`}>
                        <Form.Label>Task {taskIndex + 1}</Form.Label>
                        <Form.Control
                            value={task.description}
                            disabled={disabled}
                            onChange={event => updateTask(taskIndex, { description: event.target.value })}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Photos ({task.photoUrls.length}/5)</Form.Label>
                        <Form.Control
                            type="file"
                            multiple
                            accept="image/*"
                            disabled={disabled || uploadingTask === taskIndex || task.photoUrls.length >= 5}
                            onChange={event => uploadPhotos(taskIndex, event)}
                        />
                    </Form.Group>
                    {uploadingTask === taskIndex && <div className="mt-2">Uploading photos...</div>}
                    {task.photoUrls.length > 0 && (
                        <div className="d-flex flex-wrap gap-2 mt-2">
                            {task.photoUrls.map((photoUrl, photoIndex) => (
                                <div key={`${photoUrl}-${photoIndex}`}>
                                    <a href={photoUrl} target="_blank" rel="noopener noreferrer">Photo {photoIndex + 1}</a>
                                    <Button
                                        type="button"
                                        size="sm"
                                        variant="outline-danger"
                                        className="ms-2"
                                        disabled={disabled}
                                        onClick={() => updateTask(taskIndex, { photoUrls: task.photoUrls.filter((_photo, index) => index !== photoIndex) })}
                                    >
                                        Remove
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </section>
    );
}
